var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-form', {
    ref: "form",
    model: {
      value: _vm.isFormValid,
      callback: function ($$v) {
        _vm.isFormValid = $$v;
      },
      expression: "isFormValid"
    }
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('profile.company_name'),
      "rules": _vm.requiredRules,
      "small": "",
      "dense": "",
      "outlined": "",
      "required": "",
      "error-messages": _vm.fieldErrors.name
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "vat-field",
    attrs: {
      "label": _vm.$t('vat_number'),
      "rules": [_vm.taxIdRule],
      "small": "",
      "dense": "",
      "outlined": "",
      "error-messages": _vm.fieldErrors.tax_identifier
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('v-menu', {
          attrs: {
            "open-on-hover": "",
            "close-delay": "200",
            "close-on-content-click": false,
            "transition": "fade-transition"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref) {
              var on = _ref.on,
                attrs = _ref.attrs;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "vat-info-btn",
                attrs: {
                  "icon": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "color": "primary"
                }
              }, [_vm._v("mdi-information-outline")])], 1)];
            }
          }])
        }, [_c('div', {
          staticClass: "custom-tooltip pa-3 black--text body-2",
          staticStyle: {
            "max-width": "300px"
          }
        }, [_c('div', {
          directives: [{
            name: "help-center-links",
            rawName: "v-help-center-links"
          }],
          domProps: {
            "innerHTML": _vm._s(_vm.$t('vat_number_help_text', {
              url: _vm.helpCenterUrls[_vm.language] ? _vm.helpCenterUrls[_vm.language] : _vm.helpCenterUrls['en']
            }))
          }
        })])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.tax_identifier,
      callback: function ($$v) {
        _vm.$set(_vm.form, "tax_identifier", $$v);
      },
      expression: "form.tax_identifier"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }